
/**
 * Parse a full name into first name and last name components
 * @param fullName The full name to parse
 * @returns Object containing firstName and lastName
 */
export function parseFullName(fullName: string | null | undefined): { firstName: string | null; lastName: string | null } {
  if (!fullName) return { firstName: null, lastName: null };
  
  const nameParts = fullName.trim().split(/\s+/);
  if (nameParts.length === 0) return { firstName: null, lastName: null };
  
  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: null };
  }
  
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(' ');
  return { firstName, lastName };
}
